<template>
  <div>
    <htmlHeader :top_index="4" :menuCode="false" :crumbsShow="true" />
    <div style="width: 1200px; margin: auto;     padding-bottom: 10%; overflow: hidden;">
      <div style="overflow: hidden; margin-top: 2%;">
        <div class="news_left">
        <div class="news_left_title">{{news_data.articleTitle}}</div>
        <div style="width: 75%; margin: 2% auto;">
          <a-row>
            <a-col :span="8" class="news_time">作者：{{news_data.author}}</a-col>
            <a-col :span="8" class="news_time">发布时间：{{news_data.createdAt}}</a-col>
            <a-col :span="8" class="news_time">点击量：{{news_data.clicks}}</a-col>
          </a-row>
        </div>
        <div style="width: 100%;height: 1px; background: #EDE9E9;margin-top: 2%;"></div>
        <div style="width: 100%; margin-top: 30px;margin-bottom: 110px" v-html="news_data.articleBody"></div>
        <dl v-if="list_file.length">
          <dt>附件：</dt>
          <dd v-for="i in list_file" :key="i.uid">
            <span>{{i.name}}</span>
            <a :href="i.url" target="_blank">下载/查看</a>
          </dd>
        </dl>
        <div style="overflow: hidden;" hidden>
          <div class="news_share">分享到：</div>
          <img src="../assets/weixin.png" class="share_icon" alt="">
          <img src="../assets/pengyouquan.png" class="share_icon" alt="">
          <img src="../assets/weibo.png" class="share_icon" alt="">
          <img src="../assets/kongjian.png" class="share_icon" alt="">
        </div>
        <div v-if="last" class="xiayipian" @click="get_news_detail(last.uuid)">上一篇：{{last.articleTitle}}</div>
        <div v-if="next" class="xiayipian" @click="get_news_detail(next.uuid)" style="padding-bottom: 4%;">下一篇：{{next.articleTitle}}</div>
        </div>
        <div style="width: 28%; margin-left: 2%; float: left;">
          <div style="overflow: hidden;">
            <div class="right_line"></div>
            <div class="zuixinzixun">最新资讯</div>
          </div>
          <div style="margin-top: 4%;cursor: pointer;" :key="index" v-for="(item,index) in news_upToDate">
            <router-link tag="a" target="_blank" :to="'/news_details?uuid=' + item.uuid">
            <div class="zuixinzixun_txt1">{{item.articleTitle}}</div>
            <div class="zuixinzixun_txt2">发布时间：{{item.releaseTime}}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <foot/>
  </div>
</template>

<script>
import axios from "axios";
import userLeft from "../public/user_left";
import htmlHeader from "../public/head";
import foot from "../public/foot";
export default {
        name: "NewsDetail",
        components: {
          userLeft,
          htmlHeader,
          foot,
        },
        data() {
            return {
              news_data: '',  //新闻数据
              previous_news: '', //上一篇
              next_news: '', //下一篇
              news_upToDate: '', //最新资讯
              list_file: [],
              last: null,
              next: null,
            };
        },
        filters: {
          urlFile(value) {
            return '/api/file/download/' + value
          },
        },
        methods: {
          // 获取新闻列表
          get_news_list() {
            let obj = {
              size: 10,
            };
            this.api.get_news_list(obj).then((res) => {
              if (res.ok) {
                res.data.content.forEach((element, index) => {
                  if(element.uuid == this.$route.query.uuid) {
                    try {
                      this.previous_news = res.data.content[index - 1]
                      this.next_news = res.data.content[index + 1]
                      console.log(this.previous_news, this.next_news);
                    } catch (error) {

                    }
                  }
                })

              } else {
                this.$message.error(res.message);
              }
            });
          },
          to_details(e) {
            this.$router.push("/news_details?uuid=" + e)
          },
          // 最新资讯
          get_news_upToDate() {
            this.api.get_news_upToDate().then(res => {
              if(res.ok) {
                this.news_upToDate = res.data
              }else {
                this.$message.error(res.message)
              }
            })
          },
          xiayipian() {},
          shangyipian() {
            // this.$router.push("/news_details?uuid=" + e)
          },
          get_news_detail(id) {
            console.log(id);
            this.api.get_news_detail(id).then(res => {
              this.list_file = []
              if(res.ok) {
                this.news_data = res.data
                if (res.data.articleAttachment) {
                  res.data.articleAttachment.forEach(i => {
                    i = JSON.parse(i)
                    this.list_file.push({
                      name: i.name,
                      url: `/api/file/download/${i.response.data.uuid}`,
                    })
                  })
                }
                this.last = res.data.last
                this.next = res.data.next
              }else {
                this.$message.error(res.message)
              }
            })
          }
        },
        created() {
          const id = this.$route.query.uuid
          this.get_news_detail(id)
          this.get_news_upToDate()
          //this.get_news_list()
        },
    };
</script>

<style scoped>
dl {margin-bottom: 30px;color: #666;}
dt {float: left;}
dd {margin-left: 3em;}
dd > span {margin-right: 85px;}
dd > a {color: #666;}

  .zuixinzixun_txt2 {
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #9A9A9A;

  }
  .zuixinzixun_txt1 {
font-size: 16px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #666666;

  }
  .zuixinzixun {
font-size: 20px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #444444;
float: left;
margin-left: 2%;

  }
  .right_line {
    width: 2px;height: 19px;background: #2C9A34;
    float: left;
    margin-top: 5px;
  }
 .xiayipian {
  cursor: pointer;
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #343434;
margin-top: 2%;
  }
  .share_icon {
    width: 26px; height: 26px; float: left; margin-left: 2%;
  }
  .news_share {
font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #343434;
float: left;
cursor: pointer;

  }
  .news_time {
    text-align: center;
font-size: 12px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #666666;

  }
  .news_left_title {
font-size: 24px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #343434;
text-align: center;
  }
.news_left {
  width: 70%;
  float: left;
}
.news_right {
  width: 30%;
  float: left;
}
    .box1 {
        width: 220px;
        min-height: 1023px;
        border: 1px solid #EDE9E9;
        float: left;
        margin-top: 2%;
    }

    .box2 {
        width: 100%;
        height: 45px;
        background: #F2F2F2;
    }
</style>



// WEBPACK FOOTER //
// src/components/news_details.vue